/* ==========================================================================
   LF Outlet, carrito deslizable
   Todo lo que se agrega al carrito abre el carrito lateral, nunca la página
   /cart. Horizon ya lo hace con sus botones cuando está activo "Abrir carrito
   automáticamente"; este archivo lo hace para lo propio:

   - window.lfAvisarCarrito(): lo usan "Arma tu pack" y los sugeridos. Lee el
     carrito, avisa al tema con el evento cart:update (el carrito se redibuja
     y el contador del ícono se actualiza) y abre el carrito lateral.
   - Botones "Agregar" de "Completa tu pedido" (snippets/lf-cruzada.liquid).
   ========================================================================== */
(function () {
  'use strict';

  if (window.lfAvisarCarrito) return;

  async function avisar(origen) {
    let carrito = null;
    try {
      carrito = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    } catch (e) {
      // sin el carrito igual se avisa: el carrito lateral se redibuja solo
    }

    const evento = new Event('cart:update', { bubbles: true });
    evento.detail = {
      resource: carrito || {},
      sourceId: origen,
      data: { source: origen, itemCount: carrito ? carrito.item_count : undefined },
    };
    document.dispatchEvent(evento);

    const lateral = document.querySelector('cart-drawer-component');
    if (lateral && typeof lateral.open === 'function') {
      lateral.open();
      return true;
    }
    return false;
  }

  window.lfAvisarCarrito = avisar;

  // "Completa tu pedido": el carrito se redibuja entero después de agregar,
  // así que el clic se escucha en el documento y no en cada botón
  document.addEventListener('click', async (e) => {
    const boton = e.target.closest('[data-lf-cruzada-agregar]');
    if (!boton || boton.disabled) return;
    e.preventDefault();

    const seccion = boton.closest('.lf-cruzada');
    const error = seccion && seccion.querySelector('[data-lf-cruzada-error]');
    const texto = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Agregando…';
    if (error) error.hidden = true;

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(boton.dataset.lfCruzadaAgregar), quantity: 1 }] }),
      });
      if (!r.ok) {
        const cuerpo = await r.json().catch(() => ({}));
        throw new Error(cuerpo.description || cuerpo.message || 'No se pudo agregar.');
      }
      boton.textContent = 'Agregado';
      await avisar('lf-cruzada');
    } catch (err) {
      boton.textContent = texto;
      boton.disabled = false;
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    }
  });
})();
